import { NavLink, Link } from "react-router-dom";
import { Fish } from "lucide-react";

const linkCls = ({ isActive }) =>
  `text-sm font-medium tracking-wide transition-colors duration-200 ${
    isActive ? "text-[#C95B3B]" : "text-foreground hover:text-[#C95B3B]"
  }`;

export const Header = () => {
  return (
    <header className="glass-header sticky top-0 z-40" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <Fish className="w-6 h-6 text-[#2D5A4C]" strokeWidth={1.5} />
          <span className="font-display text-2xl tracking-tight">ecofisherman<span className="text-[#C95B3B]">.</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/regulations" className={linkCls} data-testid="nav-regulations">Regulations</NavLink>
          <NavLink to="/gear" className={linkCls} data-testid="nav-gear">Eco Gear</NavLink>
          <NavLink to="/journal" className={linkCls} data-testid="nav-journal">Journal</NavLink>
          <NavLink to="/about" className={linkCls} data-testid="nav-about">About</NavLink>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/regulations" className="btn-accent text-sm py-2 px-4" data-testid="header-cta">
            Check the Map
          </Link>
        </div>
      </div>
    </header>
  );
};
